module.exports = __webpack_public_path__ + "r-v3/img/auto.8c72c02e.jpg";